import { api } from '../apiClient';

export interface DashboardLayoutWidget {
  id?: number;
  dashboard_id?: number;
  widget_key: string;
  custom_title?: string | null;
  grid_x: number;
  grid_y: number;
  grid_w: number;
  grid_h: number;
  collapsed: boolean;
  config_json?: any;
  sort_order?: number;
}

/** A Center Console section (CC-A): `user_dashboards.sections_json`, in order. */
export interface DashboardSection {
  id: string;
  name: string;
}

export interface UserDashboard {
  id: number;
  user_id: number;
  name: string;
  is_default: number;
  sort_order: number;
  created_at: string;
  /** Parsed `sections_json`: null = never set up (the role's default set starts it). */
  sections?: DashboardSection[] | null;
  sections_json?: string | null;
}

export const dashboardLayoutApi = {
  getDashboards: (): Promise<{ success: boolean; data: UserDashboard[] }> =>
    api.get('/user-dashboards').then(r => r.data),
  createDashboard: (name: string, sections?: DashboardSection[]): Promise<{ success: boolean; data: UserDashboard }> =>
    api.post('/user-dashboards', sections ? { name, sections } : { name }).then(r => r.data),
  updateDashboard: (id: number, data: { name?: string; is_default?: boolean; sections?: DashboardSection[] }): Promise<{ success: boolean; data: UserDashboard }> =>
    api.put(`/user-dashboards/${id}`, data).then(r => r.data),
  deleteDashboard: (id: number): Promise<{ success: boolean }> =>
    api.delete(`/user-dashboards/${id}`).then(r => r.data),
  getLayout: (dashboardId?: number): Promise<{ success: boolean; data: DashboardLayoutWidget[] }> =>
    api.get('/dashboard-layout', { params: dashboardId ? { dashboard_id: dashboardId } : {} }).then(r => r.data),
  /** One save: the widgets and (CC-A) the sections together, so they never disagree. */
  saveLayout: (widgets: DashboardLayoutWidget[], dashboardId?: number, sections?: DashboardSection[]): Promise<{ success: boolean; data: DashboardLayoutWidget[] }> =>
    api.put('/dashboard-layout', sections ? { widgets, dashboard_id: dashboardId, sections } : { widgets, dashboard_id: dashboardId }).then(r => r.data),
  patchWidget: (widgetKey: string, updates: Partial<DashboardLayoutWidget> & { dashboard_id?: number }): Promise<{ success: boolean; data: DashboardLayoutWidget }> =>
    api.patch(`/dashboard-layout/${widgetKey}`, updates).then(r => r.data),
};
